module.exports = __webpack_public_path__ + "img/9788954637589.f1e8440a.jpg";